const removeProductFromCartListener = () => {
    const removeProductFromCartElements = [
        ...document.querySelectorAll('.js-remove-product-from-cart'),
    ].filter((el) => !el.dataset.removeProductFromCartInitialized);

    removeProductFromCartElements.forEach((el) => {
        el.addEventListener('click', () => {
            const productData = el.getAttribute('datalayer');

            window.dispatchEvent(
                new CustomEvent('datalayer.remove_from_cart', {
                    detail: { productData },
                })
            );
        });

        el.dataset.removeProductFromCartInitialized = true;
    });
};

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        removeProductFromCartListener();
    });
});
